import React, { useEffect } from 'react';
import { ToastContainer as ReactToastContainer } from 'react-toastify';
import { useTheme } from '@mui/material';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ToastContainer = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  useEffect(() => {
    // Injeta estilos customizados no DOM
    const styleId = 'toast-custom-styles';
    let styleElement = document.getElementById(styleId);
    
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    const backgroundColor = theme.palette.background.paper || (isDark ? '#2d3636' : '#FFFFFF');
    const borderColor = theme.palette.border.primary;
    const textColor = theme.palette.text.primary;
    const hoverBg = theme.palette.background.hover;
    const warningColor = theme.palette.warning.main;
    const errorColor = theme.palette.error.main;
    const successColor = theme.palette.success.main;
    const primaryColor = theme.palette.primary.main;
    const shadow = theme.shadows[6];

    styleElement.textContent = `
      /* Posicionamento específico para bottom-center */
      .Toastify__toast-container--bottom-center {
        position: fixed !important;
        bottom: 16px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        top: auto !important;
        right: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        width: auto !important;
        z-index: 1400 !important;
      }
      
      .Toastify__toast {
        min-height: auto !important;
        border-radius: 12px !important;
        padding: 12px 16px !important;
        display: flex !important;
        align-items: flex-start !important;
        gap: 8px !important;
        box-shadow: ${shadow} !important;
        max-width: 360px !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
        border: 1px solid ${borderColor} !important;
        background-color: ${backgroundColor} !important;
        color: ${textColor} !important;
        margin-bottom: 8px !important;
        font-family: ${theme.typography.fontFamily} !important;
      }
      
      .Toastify__toast-body {
        padding: 0 !important;
        margin: 0 !important;
        display: flex !important;
        align-items: flex-start !important;
        gap: 8px !important;
        flex: 1 !important;
        color: ${textColor} !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
      }
      
      .Toastify__toast-icon {
        width: 20px !important;
        height: 20px !important;
        margin-top: 2px !important;
        flex-shrink: 0 !important;
      }
      
      .Toastify__toast-icon svg {
        width: 20px !important;
        height: 20px !important;
      }
      
      .Toastify__toast--warning .Toastify__toast-icon {
        color: ${warningColor} !important;
      }
      
      .Toastify__toast--error .Toastify__toast-icon {
        color: ${errorColor} !important;
      }
      
      .Toastify__toast--success .Toastify__toast-icon {
        color: ${successColor} !important;
      }
      
      .Toastify__toast--info .Toastify__toast-icon {
        color: ${primaryColor} !important;
      }
      
      .Toastify__close-button {
        position: absolute !important;
        top: 8px !important;
        right: 8px !important;
        width: 24px !important;
        height: 24px !important;
        padding: 0 !important;
        opacity: 0.7 !important;
        color: var(--toast-close-button-color) !important;
      }
      
      .Toastify__close-button:hover {
        opacity: 1 !important;
        background-color: ${hoverBg} !important;
      }
      
      .Toastify__close-button svg {
        width: 16px !important;
        height: 16px !important;
      }
      
      .Toastify__progress-bar {
        height: 3px !important;
        border-radius: 999px !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
      }
      
      .Toastify__progress-bar--warning {
        background: ${warningColor} !important;
      }
      
      .Toastify__progress-bar--error {
        background: ${errorColor} !important;
      }
      
      .Toastify__progress-bar--success {
        background: ${successColor} !important;
      }
      
      .Toastify__progress-bar--info {
        background: ${primaryColor} !important;
      }
    `;

    return () => {
      // Limpa os estilos quando o componente desmonta ou o tema muda
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.textContent = '';
      }
    };
  }, [theme, isDark]);

  return (
    <ReactToastContainer
      position="bottom-center"
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      rtl={false}
      pauseOnFocusLoss
      draggablePercent={60}
      autoClose={3000}
      hideProgressBar={false}
      closeButton={({ closeToast }) => (
        <IconButton
          size="small"
          onClick={closeToast}
          sx={{
            width: '24px',
            height: '24px',
            padding: 0,
            borderRadius: '999px',
            color: 'var(--toast-close-button-color)',
            '&:hover': {
              backgroundColor: theme.palette.background.hover,
            },
          }}
        >
          <CloseIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      )}
    />
  );
};

export default ToastContainer;

